import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const TokenDetails = () => {
    const { token } = useParams();
    const [cartDetails, setCartDetails] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    

    useEffect(() => {
        const fetchCartDetails = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/token-details/${token}`);
                setCartDetails(response.data.cartItems);
            } catch (error) {
                console.error('Erreur lors de la récupération des détails du panier :', error);
            }
        };

        fetchCartDetails();
    }, [token]);


    useEffect(() => {
        if (cartDetails.length === 0) return; // ⛔ don't proceed if cart is empty
    
        const orderDetails = {
          orderId:token,
          customerName: 'Raja Phanendra',
          items: cartDetails.map(item => ({
            name: item.itemName,
            qty: item.quantity,
            price: item.price
          })),
          totalAmount: cartDetails.reduce(
            (total, item) => total + item.price * item.quantity,
            0
          )
        };
    
        const sendPrintRequest = async () => {
          try {
            await axios.post(`${API_URL}/api/print`, [
              { order: orderDetails }
            ]);
           
          } catch (err) {
            console.error('Printing failed', err);
            alert('Printing failed');
          }
        };
    
        // wait 3 sec before sending
        const timer = setTimeout(sendPrintRequest, 3000);
    
        return () => clearTimeout(timer);
      }, [cartDetails]); // ✅ runs only when cartDetails is populated

    const handlePrintOrderPage = () => {
        console.log("link selected")
        navigate('/printorder');
    };

    return (
        <div className="main-container">
            {/* Header */}
            <header className="header">
                <div className="container">
                    <div className="header-content">
                        <div className="header-logo">Lememeprix</div>
                        <div className="header-actions">
                            <div className="address-input">
                                <i className="fa-solid fa-location-dot"></i>
                            </div>
                            <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg" alt="Profile" className="profile-image" />
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="main-content">
                {/* Hero Section */}
                <section className="hero-section">
                    <img className="hero-image" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/bad7b0c250-4c9b57a3fcee60257f74.png" alt="Chef preparing food" />
                    <div className="hero-overlay"></div>
                </section>

                {/* Order Details Card */}
                <section className="order-details">
                    <div className="container">
                        <div className="details-card">
                            <div className="order-status">
                                <h2 className="order-number">Commande #{token}</h2>
                                <span className="status-tag">En cours</span>
                            </div>

                            {/* Progress Bar */}
                            <div className="progress-bar">
                                <div className="timeline-steps">
                                    <div className="timeline-step">
                                        <div className="step-icon">
                                            <i className="fa-solid fa-check"></i>
                                        </div>
                                        <p className="step-label">Confirmée</p>
                                    </div>
                                    <div className="timeline-step">
                                        <div className="step-icon">
                                            <i className="fa-solid fa-utensils"></i>
                                        </div>
                                        <p className="step-label">Préparation</p>
                                    </div>
                                    <div className="timeline-step">
                                        <div className="step-icon">
                                            <i className="fa-solid fa-motorcycle"></i>
                                        </div>
                                        <p className="step-label">En chemin</p>
                                    </div>
                                    <div className="timeline-step">
                                        <div className="step-icon">
                                            <i className="fa-solid fa-flag-checkered"></i>
                                        </div>
                                        <p className="step-label">Livrée</p>
                                    </div>
                                </div>
                                <div className="progress-line">
                                    <div className="progress-bar-fill"></div>
                                </div>
                            </div>

                            {/* Order Items */}
                            <div className="order-items">
                                <h3 className="items-title">Articles de la commande</h3>
                                <button >
                                  
                                  <span  onClick={handlePrintOrderPage}>Print Order Details</span>
                              </button>
                                {cartDetails ? (
                                    cartDetails.map((item) => (
                                        <div key={item._id} className="item">
                                            <p className="item-name">{item.itemName}</p>
                                            <p className="item-details">Quantité: {item.quantity}</p>
                                            <p className="item-price">€{item.price * item.quantity}</p>
                                        </div>
                                    ))
                                ) : (
                                    <p>Chargement des détails du panier...</p>
                                )}
                            </div>

                            {/* Order Summary */}
                            <div className="order-summary">
                                <div className="summary-details">
                                    {/* <div className="detail">
                                        <span>Subtotal</span>
                                        <span>€15.00</span>
                                    </div> */}
                                    {/* <div className="detail">
                                        <span>Delivery Fee</span>
                                        <span>€2.50</span>
                                    </div> */}
                                    {/* <div className="detail total">
                                        <span>Total</span>
                                        <span>€17.50</span>
                                    </div> */}
                                </div>

                                {/* Delivery Info */}
                                {/* <div className="delivery-info">
                                    <div className="info-item">
                                        <i className="fa-solid fa-clock"></i>
                                        <span>Livraison estimée : 14 h 30 - 14 h 45</span>
                                    </div>
                                    <div className="info-item">
                                        <i className="fa-solid fa-location-dot"></i>
                                        <span>123 Rue de Paris, 75001 Paris</span>
                                    </div>
                                </div> */}
                                <div className="action-buttons">
                                    <button className="contact-button">
                                        <i className="fa-solid fa-phone"></i>
                                        Contacter le restaurant
                                    </button>
                                    <button className="reorder-button">
                                        <i className="fa-solid fa-arrows-rotate"></i>
                                        Commander à nouveau les articles
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h4 className="footer-title">Liens rapides</h4>
                            <ul className="footer-links">
                                <li><span className="footer-link">À propos de nous</span></li>
                                <li><span className="footer-link">Contact</span></li>
                                <li><span className="footer-link">Politique de confidentialité</span></li>
                            </ul>
                        </div>
                        <div className="footer-section">
                            <h4 className="footer-title">Suivez-nous</h4>
                            <div className="social-icons">
                                <span className="social-icon"><i className="fa-brands fa-facebook"></i></span>
                                <span className="social-icon"><i className="fa-brands fa-instagram"></i></span>
                                <span className="social-icon"><i className="fa-brands fa-twitter"></i></span>
                            </div>
                        </div>
                        <div className="footer-section">
                            <h4 className="footer-title">Assistance</h4>
                            <p className="contact-info">Email: support@lememeprix.com</p>
                            <p className="contact-info">Phone: +33 1 23 45 67 89</p>
                        </div>
                    </div>
                </div>
            </footer>

            <style jsx>{`
/* Main container */
.main-container {
        min-height: 100vh;
        background-color: #f9fafb;
        display: flex;
        flex-direction: column;
    }

  /* Header */
  .header {
       position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            background-color: #fff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            z-index: 50;
}

        .header .container {
           max-width: 1200px;
            margin: 0 auto;
                padding: 0 1rem;
              }

        .header-content {
            display: flex;
            align-items: center;
                justify-content: space-between;
               padding: 1rem;
               }

        .header-logo {
            font-size: 1.5rem;
            font-weight: bold;
              }

            .address-input {
            position: relative;
            flex: 1;
                margin: 0 1rem;
                }

             .address-input input {
              width: 100%;
             padding: 0.75rem 1rem;
              border: 1px solid #e5e7eb;
             border-radius: 0.5rem;
               outline: none;
                 padding-left: 2.5rem;
                  }

            .address-input i {
           position: absolute;
                left: 1rem;
                top: 50%;
                transform: translateY(-50%);
                   color: #6b7280;
                     }

           .header-actions {
           display: flex;
                   align-items: center;
                   gap: 1rem;
                   }

        /* Style for header profile image */
        .profile-image {
            width: 3rem;
            height: 3rem;
            border-radius: 9999px;
            object-fit: cover;
        }

        /* Hero Section */
            .hero-section {
        position: relative;
            height: 400px;
}

.hero-image {
    width: 100%;
        height: 100%;
        object-fit: cover;
}

.hero-overlay {
    position: absolute;
        inset: 0;
             background-color: rgba(0, 0, 0, 0.4);
 }

   /* Order Details Section */
        .order-details {
              margin-top: -5rem;
          position: relative;
            z-index: 10;
          }

        .details-card {
         background-color: #fff;
            border-radius: 0.75rem;
             box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                padding: 2rem;
                 max-width: 48rem;
                       margin: 0 auto;
 }

       .order-status {
        display: flex;
               justify-content: space-between;
                     align-items: center;
           margin-bottom: 1.5rem;
              }

        .order-number {
           font-size: 1.5rem;
              font-weight: bold;
            }

        .status-tag {
            background-color: #fef2f2;
               color: #ef4444;
                padding: 0.5rem 1rem;
                     border-radius: 9999px;
        font-size: 0.875rem;
            }

        /* Progress Bar */
       .progress-bar {
        margin-bottom: 2rem;
                  }

                 .timeline-steps {
                    display: flex;
                   justify-content: space-between;
                       position: relative;
                }

              .timeline-steps::before {
                content: "";
                   position: absolute;
                      top: 50%;
                          left: 0;
                              right: 0;
                   height: 0.125rem;
                       background-color: #e5e7eb;
                    transform: translateY(-50%);
                        }

                  .timeline-step {
                text-align: center;
                  position: relative;
                   }

               .step-icon {
                width: 2.5rem;
                       height: 2.5rem;
                       border-radius: 9999px;
                background-color: #e5e7eb;
                         color: #4b5563;
                           display: flex;
                        align-items: center;
                                justify-content: center;
                         margin: 0 auto;
                      z-index: 1;
                                }

            .step-label {
                 margin-top: 0.5rem;
            font-size: 0.875rem;
             font-weight: 500;
               }

          /* Progress Bar Fill */
            .progress-line {
           height: 0.25rem;
                 background-color: #e5e7eb;
            border-radius: 9999px;
           overflow: hidden;
                 }

               .progress-bar-fill {
              height: 100%;
                width: 50%; /* Adjust as needed */
                      background-color: #ef4444;
             border-radius: 9999px;
                      }

       /* Order Items */
                .order-items {
                    padding: 1.5rem 0;
                     border-top: 1px solid #e5e7eb;
                  border-bottom: 1px solid #e5e7eb;
                 }

                .items-title {
                     font-size: 1.25rem;
                       font-weight: bold;
                           margin-bottom: 1rem;
             }

               .item {
                   display: flex;
                      justify-content: space-between;
                    align-items: center;
                           margin-bottom: 0.75rem;
                 color: #4b5563;
                    }

                    /* Order Summary */
            .order-summary {
                    padding: 1.5rem 0;
                         }

               .summary-details {
                }

            .detail {
                  display: flex;
                justify-content: space-between;
                  margin-bottom: 0.75rem;
                   color: #374151;
                    }

                    .detail.total {
                    font-weight: bold;
                       font-size: 1.125rem;
                     }

               .delivery-info {
                    background-color: #f9fafb;
                      padding: 1rem;
                    border-radius: 0.5rem;
              }

           .info-item {
                 display: flex;
                    align-items: center;
                         gap: 0.5rem;
                         margin-bottom: 0.5rem;
                 color: #4b5563;
                     }

            .action-buttons {
               display: flex;
                gap: 1rem;
                  }

            .action-buttons button {
              padding: 0.75rem 1.5rem;
                 border-radius: 0.5rem;
                   color: #fff;
                         background-color: #1f2937;
                transition: background-color 0.2s ease;
                     border: none;
                cursor: pointer;
                  flex: 1;
                                 }

                                  .action-buttons button:hover {
                                    background-color: #374151;
                                    }

            /* Footer */
                 .footer {
            background-color: #f9fafb;
                 padding: 3rem 0;
                margin-top: 4rem;
                        }

        .footer .container {
             max-width: 1200px;
                 margin: 0 auto;
                       padding: 0 1rem;
                 }

               .footer-content {
                     display: grid;
                        grid-template-columns: repeat(1, 1fr);
                         gap: 2rem;
               }

            @media (min-width: 768px) {
            .footer-content {
                grid-template-columns: repeat(3, 1fr);
                    }
            }

           .footer-section {
            display: flex;
              flex-direction: column;
                 }

              .footer-title {
                 font-size: 1.25rem;
                  font-weight: bold;
                 margin-bottom: 1rem;
                }

              .footer-links {
                 list-style: none;
                       padding: 0;
                  }

        .footer-links li {
            margin-bottom: 0.5rem;
               }

            .footer-link {
               color: #4b5563;
                  cursor: pointer;
                        transition: color 0.2s ease;
                 text-decoration: none;
             }

        .footer-link:hover {
             color: #6b7280;
               }

            .social-icons {
                display: flex;
                    gap: 1rem;
               }

            .social-icons i {
                font-size: 1.5rem;
                  color: #4b5563;
                   cursor: pointer;
                    transition: color 0.2s ease;
               }

            .social-icons i:hover {
            color: #6b7280;
             }

        .contact-info {
            display: flex;
             flex-direction: column;
          }

       .contact-details {
           display: flex;
                align-items: center;
                gap: 0.5rem;
                  margin-bottom: 0.5rem;
                  color: #4b5563;
        }
            `}</style>
        </div>
    );
};

export default TokenDetails;